var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 2.35767C4.8852 2.35767 2.35963 4.88325 2.35963 7.9987C2.35963 11.1142 4.8852 13.6397 8.00065 13.6397C11.1161 13.6397 13.6417 11.1142 13.6417 7.9987C13.6417 4.88325 11.1161 2.35767 8.00065 2.35767ZM1.33398 7.9987C1.33398 4.3168 4.31875 1.33203 8.00065 1.33203C11.6825 1.33203 14.6673 4.3168 14.6673 7.9987C14.6673 11.6806 11.6825 14.6654 8.00065 14.6654C4.31875 14.6654 1.33398 11.6806 1.33398 7.9987ZM7.48783 5.26366C7.48783 4.98043 7.71743 4.75083 8.00065 4.75083H8.00749C8.29071 4.75083 8.52031 4.98043 8.52031 5.26366C8.52031 5.54688 8.29071 5.77648 8.00749 5.77648H8.00065C7.71743 5.77648 7.48783 5.54688 7.48783 5.26366ZM6.80407 7.9987C6.80407 7.71548 7.03367 7.48588 7.31689 7.48588H8.00065C8.28387 7.48588 8.51347 7.71548 8.51347 7.9987V10.2209H8.68441C8.96763 10.2209 9.19723 10.4505 9.19723 10.7337C9.19723 11.017 8.96763 11.2466 8.68441 11.2466H8.00065C7.71743 11.2466 7.48783 11.017 7.48783 10.7337V8.51152H7.31689C7.03367 8.51152 6.80407 8.28192 6.80407 7.9987Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconGrey);
export default __webpack_public_path__ + "static/media/info-icon-grey.1862c3270bb0dfa70558a9e61ddbbe40.svg";
export { ForwardRef as ReactComponent };